import { opt } from '../lib/media';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Instagram, ArrowRight } from 'lucide-react';
import { footerLinks, LOGO_URL } from '../mock';
import { subscribeNewsletter } from '../api';
import { toast } from 'sonner';

const OFFERS = [
  '10% off your first custom order',
  'Early access to Diwali slots',
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const offer = OFFERS[new Date().getDate() % OFFERS.length];
  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try { await subscribeNewsletter(email); } catch (error) { console.error('Newsletter subscription error:', error); }
    toast.success('Welcome to the HITÉRA world', { description: `Your reward: ${offer}. We'll be in touch soon.` });
    setEmail('');
  };

  const slugFor = (name) => name.toLowerCase().replace(/[^a-z]+/g, '-').replace(/^-|-$/g, '');

  return (
    <footer className="bg-burgundy-950 text-cream/80">
      {/* Newsletter */}
      <div className="border-b border-gold/15">
        <div className="max-w-[1100px] mx-auto px-6 py-16 text-center">
          <p className="text-gold tracking-luxe text-xs uppercase mb-4">The HITÉRA Atelier</p>
          <h3 className="font-display text-3xl md:text-4xl text-cream mb-3">Join Our World of Timeless Elegance</h3>
          <p className="text-cream/60 max-w-lg mx-auto mb-3 text-sm">Be the first to discover new collections, private previews and heritage craft stories.</p>
          <p className="text-gold text-sm mb-8 tracking-wide" data-testid="newsletter-offer">Sign up &amp; enjoy <span className="text-gold-light font-medium">{offer}</span>.</p>
          <form onSubmit={subscribe} className="flex max-w-md mx-auto border-b border-gold/40 pb-2">
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Enter your email address" className="flex-1 bg-transparent outline-none text-cream placeholder:text-cream/40 text-sm tracking-wide" />
            <button type="submit" className="text-gold hover:text-gold-light transition-colors"><ArrowRight size={22} /></button>
          </form>
        </div>
      </div>

      {/* Links */}
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2 md:col-span-2">
          <img src={opt(LOGO_URL, 200)} alt="HITÉRA" className="h-20 rounded-sm mb-5" />
          <p className="text-sm text-cream/55 max-w-xs leading-relaxed">Contemporary couture born of heritage craft. Each HITÉRA creation is a celebration of artistry, made to be treasured.</p>
          <div className="flex gap-5 mt-6 text-gold">
            <a href="https://www.instagram.com/hitera__" target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram-link" className="hover:text-gold-light transition-colors"><Instagram size={20} /></a>
          </div>
        </div>
        <div>
          <h4 className="text-gold text-xs tracking-luxe uppercase mb-5">Shop</h4>
          <ul className="space-y-3 text-sm">
            {footerLinks.shop.map((l) => (
              <li key={l}><Link to={`/shop/${slugFor(l)}`} className="hover:text-gold transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-gold text-xs tracking-luxe uppercase mb-5">The House</h4>
          <ul className="space-y-3 text-sm">
            {footerLinks.house.map((l) => (
              <li key={l}><Link to="/about" className="hover:text-gold transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-gold text-xs tracking-luxe uppercase mb-5">Client Care</h4>
          <ul className="space-y-3 text-sm">
            {footerLinks.help.map((l) => (
              <li key={l}><Link to={l === 'Book Appointment' ? '/diwali' : '/contact'} className="hover:text-gold transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-gold/15">
        <div className="max-w-[1400px] mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-cream/40 tracking-wide">
          <p>© {new Date().getFullYear()} HITÉRA. All rights reserved.</p>
          <div className="flex gap-6">
            <span className="cursor-pointer hover:text-gold">Privacy Policy</span>
            <span className="cursor-pointer hover:text-gold">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
